/**
 * 菜单翻译 - 中文
 * key = 后端返回的菜单名（中文），value = 显示文本
 * 中文环境下 key === value
 */
export default {
  menu: {
    '首页': '首页',
    '个人中心': '个人中心',
    '系统管理': '系统管理',
    '用户管理': '用户管理',
    '费用项目管理': '费用项目管理',
    '角色管理': '角色管理',
    '菜单管理': '菜单管理',
    '部门管理': '部门管理',
    '操作日志': '操作日志',
    '编码规则': '编码规则',
    '审计日志': '审计日志',
    '字典管理': '字典管理',
    '用户权限': '用户权限',
    '系统日志': '系统日志',
    '权限分配': '权限分配',
    '组织管理': '组织管理',
    '业态类型管理': '业态类型管理',
    '业态分类': '业态分类',
    '资产管理': '资产管理',
    '资产总览': '资产总览',
    '铺位管理': '铺位管理',
    '广告位管理': '广告位管理',
    '共享空间': '共享空间',
    '楼层平面管理': '楼层平面管理',
    '招商管理': '招商管理',
    '品牌管理': '品牌管理',
    '商户管理': '商户管理',
    '招商政策': '招商政策',
    '招商工作台': '招商工作台',
    '业态规划': '业态规划',
    '模拟落位': '模拟落位',
    '品牌落位': '品牌落位',
    '招商洽谈': '招商洽谈',
    '招商意向': '招商意向',
    '招商计划': '招商计划',
    '招商任务': '招商任务',
    '正式落位': '正式落位',
    '商品管理': '商品管理',
    '合同管理': '合同管理',
    '租赁合同': '租赁合同',
    '合同列表': '合同列表',
    '合同变更': '合同变更',
    '营运管理': '营运管理',
    '现场管理': '现场管理',
    '开业筹备管理': '开业筹备管理',
    '退场管理': '退场管理',
    '销售数据管理': '销售数据管理',
    '缴费管理': '缴费管理',
    '保证金管理': '保证金管理',
    '保证金表单': '保证金表单',
    '账单管理': '账单管理',
    '费用录入': '费用录入',
    '发票管理': '发票管理',
    '开票申请': '开票申请',
    '开票处理': '开票处理',
    '发票记录': '发票记录',
    '能源计量': '能源计量',
    '设备管理': '设备管理',
    '报表中心': '报表中心',
    '资产报表': '资产报表',
    '铺位台账': '铺位台账',
    '出租率分析': '出租率分析',
    '到期预警': '到期预警',
    '招商报表': '招商报表',
    '招商进度': '招商进度',
    '财务报表': '财务报表',
    '收入月报': '收入月报',
    '收缴预警': '收缴预警',
    '报表查询': '报表查询',
    '总经理驾驶舱': '总经理驾驶舱',
    '工作流': '工作流',
    '工作流程': '工作流程',
    '待办': '待办',
    '待办任务': '待办任务',
    '已完成': '已完成',
    '已办任务': '已办任务',
    '已发起': '已发起',
    '我发起的': '我发起的',
    '流程定义': '流程定义',
    '资源定价': '资源定价',
    '打印模板管理': '打印模板管理',
    '打印模板': '打印模板',
    '模板设计器': '模板设计器',
    '能源管理': '能源管理',
    '水电煤管理': '水电煤管理',
    '仪表台账': '仪表台账',
    '抄表管理': '抄表管理',
    '单价配置': '单价配置',
    '物业管理': '物业管理',
    '工单管理': '工单管理',
    '商户账号管理': '商户账号管理',
    '通知模板': '通知模板',
    '账单详情': '账单详情',
    '收款登记': '收款登记',
    '收款记录': '收款记录',
    '新增收款': '新增收款',
    '编辑收款': '编辑收款',
    '联营合同': '联营合同',
    '联营结算': '联营结算',
    '支付工具': '支付工具',
    '付款方式': '付款方式',
    '付款周期管理': '付款周期管理',
    '收费主体': '收费主体',
    '定时任务日志': '定时任务日志',
    '凭证管理': '凭证管理',
    '凭证定义': '凭证定义',
    '凭证字段定义': '凭证字段定义',
    '凭证生成': '凭证生成',
    '结转记录': '结转记录',
    '科目对应': '科目对应',
    '部门对照': '部门对照',
    // 计划管理
    '计划管理': '计划管理',
    '年度计划': '年度计划',
    '年度计划详情': '年度计划详情',
    '执行任务': '执行任务',
    '计划调整': '计划调整',
    '计划复盘': '计划复盘',
    '经营看板': '经营看板',
    '指标管理': '指标管理',
    // 营销管理
    '营销管理': '营销管理',
    '营销活动': '营销活动',
    '优惠券管理': '优惠券管理',
    // 资产模块
    '资产调整': '资产调整',
    '资产管理首页': '资产管理首页',
    // 系统/配置
    '系统配置': '系统配置',
    '参数设置': '参数设置',
    '权限矩阵': '权限矩阵',
    '合同分段配置': '合同分段配置',
    '应收应付计划': '应收应付计划',
    // 报表子菜单
    '总经理报表': '总经理报表',
    '营运报表': '营运报表',
    '物业报表': '物业报表',
    '意向转化漏斗': '意向转化漏斗',
    '业态规划及落位分析': '业态规划及落位分析',
    '品牌与业态结构': '品牌与业态结构',
    '销售坪效分析': '销售坪效分析',
    '租户异动监控': '租户异动监控',
    '销售额统计': '销售额统计',
    '开业筹备进度': '开业筹备进度',
    '工单统计': '工单统计',
    '工单分布': '工单分布',
    '工单效率': '工单效率',
    '广告位概览': '广告位概览',
    '广告位分析': '广告位分析',
    // 招商子菜单
    '招商资源库': '招商资源库',
    '招商规划': '招商规划',
    '招商执行': '招商执行',
    '商户旅程': '商户旅程',
    '洽谈明细': '洽谈明细',
    '意向转化': '意向转化',
    // 合同子菜单
    '合同台账': '合同台账',
    '空置资产明细': '空置资产明细',
    '续签预警': '续签预警',
    // 财务子菜单
    '应收实收明细': '应收实收明细',
    '账龄分析': '账龄分析',
    '收款对账': '收款对账',
    '保证金台账': '保证金台账',
    '逾期明细': '逾期明细',
    // 销售营运子菜单
    '销售汇总': '销售汇总',
    '租售比分析': '租售比分析',
    '工单明细': '工单明细',
    '能耗分摊': '能耗分摊',
    'KPI考核报表': 'KPI考核报表',
    // 计划子菜单
    '计划执行': '计划执行',
    '计划报表': '计划报表',
    // 其他
    '租户缴费': '租户缴费',
    '登录': '登录',
    '404': '404',
    '401': '401',
  },
}
